import React from 'react'
import './PingLoading.css'
const PingLoading = () => {
    return (
        <div class="loader-container flex justify-center">
            <div class="ping"></div>
        </div>
    )
}

export default PingLoading